import type { AuditExportOptions, AuditListParams, AuditListResponse } from "@/types";
import { request, requestBlob } from "./request";

export async function listAuditHistory(
  params: AuditListParams = {},
): Promise<AuditListResponse> {
  const searchParams = new URLSearchParams();
  if (params.page !== undefined) searchParams.set("page", String(params.page));
  if (params.limit !== undefined) searchParams.set("limit", String(params.limit));
  if (params.sortBy) searchParams.set("sortBy", params.sortBy);
  if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
  if (params.riskLevel) searchParams.set("riskLevel", params.riskLevel);
  if (params.status) searchParams.set("status", params.status);
  if (params.inputType) searchParams.set("inputType", params.inputType);
  if (params.dateFrom) searchParams.set("dateFrom", params.dateFrom);
  if (params.dateTo) searchParams.set("dateTo", params.dateTo);
  if (params.userId) searchParams.set("userId", params.userId);
  if (params.q) searchParams.set("q", params.q);

  const queryString = searchParams.toString();
  const path = queryString ? `/audits?${queryString}` : "/audits";
  return request<AuditListResponse>(path);
}

export async function exportAuditJson(
  auditId: string,
  options: AuditExportOptions = {},
): Promise<Blob> {
  const searchParams = new URLSearchParams();
  if (options.includeRawText) searchParams.set("includeRawText", "true");
  const queryString = searchParams.toString();
  const path = queryString
    ? `/audits/${auditId}/export/json?${queryString}`
    : `/audits/${auditId}/export/json`;
  return requestBlob(path);
}

export async function exportAuditClaimsPdf(
  auditId: string,
  options: { lang?: "pl" | "en" } = {},
): Promise<Blob> {
  const searchParams = new URLSearchParams();
  if (options.lang) searchParams.set("lang", options.lang);
  const queryString = searchParams.toString();
  const path = queryString
    ? `/audits/${auditId}/export/claims-pdf?${queryString}`
    : `/audits/${auditId}/export/claims-pdf`;
  return requestBlob(path);
}

export async function exportAuditClaimsDocx(
  auditId: string,
  options: { lang?: "pl" | "en" } = {},
): Promise<Blob> {
  const searchParams = new URLSearchParams();
  if (options.lang) searchParams.set("lang", options.lang);
  const queryString = searchParams.toString();
  const path = queryString
    ? `/audits/${auditId}/export/claims-docx?${queryString}`
    : `/audits/${auditId}/export/claims-docx`;
  return requestBlob(path);
}
